import { AvailableVideoChatTimeSlots } from '~/types/booking'
import { homApi } from '~/redux/apis/hom'
import { Booking } from '~/types/tutoring-api'

export const bookingsApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    getTimeslots: builder.query<AvailableVideoChatTimeSlots[], { timestamp?: number; timezone: string }>({
      query({ timestamp, timezone }) {
        return {
          url: '/v1/timeslots-available',
          method: 'GET',
          params: {
            timezone,
            timestamp, // browser timestamp in milliseconds
          },
        }
      },
    }),

    getLatestBooking: builder.query<Booking | undefined, void>({
      query: () => '/v1/bookings-latest',
    }),
  }),
})

export const { useGetTimeslotsQuery, useGetLatestBookingQuery } = bookingsApi
